import React from "react";
import { useLanguage } from "@/i18n/LanguageContext";

export const Marquee = () => {
  const { t } = useLanguage();
  const words = t.marquee.words;
  const loop = [...words, ...words];
  return (
    <section className="relative border-y border-border/40 bg-secondary/20 py-8">
      <p className="mb-6 text-center text-xs uppercase tracking-[0.25em] text-muted-foreground">
        {t.marquee.label}
      </p>
      <div className="relative overflow-hidden">
        <div className="flex w-max animate-marquee items-center gap-12 px-6">
          {loop.map((w, i) => (
            <span
              key={i}
              className="font-display text-xl font-semibold text-foreground/30 transition-colors hover:text-primary sm:text-2xl"
            >
              {w}
              <span className="ml-12 text-primary/40">/</span>
            </span>
          ))}
        </div>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-background to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-background to-transparent" />
      </div>
    </section>
  );
};
